import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetDispatcherWorkplaceParams,
    GetDispatcherWorkplaceInvoicesParams,
    GetDispatcherWorkplaceResponse,
    GetDispatcherWorkplaceInvoicesResponse,
    DispatcherWorkplaceChangeDateForTakePayload,
    DispatcherWorkplacePeriod,
    DispatcherWorkplaceCreateWaitListPayload,
    DispatcherWorkplaceLoadWaitListStatusesParams,
    DispatcherWorkplaceWaitListStatus,
    DispatcherWorkplaceLoadWaitListCommentsParams,
    DispatcherWorkplaceWaitListComment,
    DispatcherWorkplaceAssignPayload,
    DispatcherWorkplaceAssignCourier,
    DispatcherWorkplaceLoadCouriersParams,
    DispatcherWorkplaceMassAppointmentTakesPayload,
    DispatcherWokrplaceExportSelfExcelParams
} from '@/modules/DispatcherWorkplaceModule/types'

type GetDispatcherWorkplaceApiResponse = Promise<AxiosResponse<GetDispatcherWorkplaceResponse>>
type GetDispatcherWorkplaceInvoicesApiResponse = Promise<AxiosResponse<GetDispatcherWorkplaceInvoicesResponse>>
type DispatcherWorkplaceChangeDateForTakeResponse = Promise<AxiosResponse<void>>
type DispatcherWorkplaceLoadPeriodsForChangeDateResponse = Promise<AxiosResponse<{ data: DispatcherWorkplacePeriod[] }>>
type DispatcherWorkplaceCreateWaitListResponse = Promise<AxiosResponse<void>>
type DispatcherWorkplaceLoadWaitListStatusesResponse = Promise<AxiosResponse<{ data: DispatcherWorkplaceWaitListStatus[] }>>
type DispatcherWorkplaceLoadWaitListCommentsResponse = Promise<AxiosResponse<{ data: DispatcherWorkplaceWaitListComment[] }>>
type DispatcherWorkplaceAssignOrderResponse = Promise<AxiosResponse<void>>
type DispatcherWorkplaceLoadCouriers = Promise<AxiosResponse<{ data: DispatcherWorkplaceAssignCourier[]; meta: { last_page: number; total: number }}>>
type DispatcherWorkplaceSetSelfDeliveryResponse = Promise<AxiosResponse<void>>
type DispatcherWorkplaceMassAppointmentTakesResponse = Promise<AxiosResponse<void>>

export function getDispatcherWorkplace(params: GetDispatcherWorkplaceParams): GetDispatcherWorkplaceApiResponse {
    return http.get('/dispatcher/api/workplace', { params })
}

export function getDispatcherWorkplaceInvoices(params: GetDispatcherWorkplaceInvoicesParams): GetDispatcherWorkplaceInvoicesApiResponse {
    return http.get('/dispatcher/api/workplace-invoices', { params })
}

export function loadPeriodsForChangeDate(): DispatcherWorkplaceLoadPeriodsForChangeDateResponse {
    return http.get('/cabinet/api/order-periods')
}

export function changeDateForTake(payload: DispatcherWorkplaceChangeDateForTakePayload): DispatcherWorkplaceChangeDateForTakeResponse {
    return http.post('/dispatcher/api/order-take/change-date', payload)
}

export function loadWaitListStatuses(params: DispatcherWorkplaceLoadWaitListStatusesParams): DispatcherWorkplaceLoadWaitListStatusesResponse {
    return http.get('/cabinet/api/wait-list-statuses', { params })
}

export function loadWaitListComments(params: DispatcherWorkplaceLoadWaitListCommentsParams): DispatcherWorkplaceLoadWaitListCommentsResponse {
    return http.get('/dispatcher/api/comment-template', { params })
}

export function createWaitList(payload: DispatcherWorkplaceCreateWaitListPayload): DispatcherWorkplaceCreateWaitListResponse {
    return http.post('/cabinet/api/wait-list-statuses', payload)
}

export function assignOrder(payload: DispatcherWorkplaceAssignPayload): DispatcherWorkplaceAssignOrderResponse {
    return http.post('/dispatcher/api/order-take/assign', payload)
}

export function loadCouriers(params: DispatcherWorkplaceLoadCouriersParams): DispatcherWorkplaceLoadCouriers {
    return http.get('/dispatcher/api/couriers', { params })
}

export function setSelfDelivery(orderId: number): DispatcherWorkplaceSetSelfDeliveryResponse {
    return http.put(`/cabinet/api/admin/orders/${orderId}/self-delivery`, {})
}

export function massAppointmentTakes(payload: DispatcherWorkplaceMassAppointmentTakesPayload): DispatcherWorkplaceMassAppointmentTakesResponse {
    return http.post('/dispatcher/api/order-take/assign', payload)
}

export function exportExcelList(params: DispatcherWokrplaceExportSelfExcelParams): Promise<AxiosResponse<Blob>> {
    return http.get(`/dispatcher/api/workplace-invoices/export`, {
        responseType: 'blob',
        params
    })
}

export default {
    getDispatcherWorkplace,
    getDispatcherWorkplaceInvoices,
    loadPeriodsForChangeDate,
    changeDateForTake,
    loadWaitListStatuses,
    loadWaitListComments,
    createWaitList,
    assignOrder,
    loadCouriers,
    setSelfDelivery,
    massAppointmentTakes,
    exportExcelList
}